/* UKOI — блок доставки на PDP: прогрес до безкоштовної доставки + реальні строки.
   Строки рахуються в браузері (актуальна дата клієнта), прогрес — з /cart.js. */
(function () {
  'use strict';

  var DEFAULT_THRESHOLD = 150000; // 1500 ₴ у копійках (умови доставки, ICECAT-716)

  // --- гроші ---------------------------------------------------------------
  function money(cents, locale) {
    var v = Math.round(cents / 100);
    var loc = locale === 'en' ? 'en-US' : 'uk-UA';
    // uk-UA дає нерозривний пробіл як роздільник тисяч — саме те, що треба
    return '₴' + v.toLocaleString(loc);
  }

  // --- дати ----------------------------------------------------------------
  // Пропускаємо неділю (кур'єри UA у неділю переважно не відправляють/не возять).
  function skipSunday(d) {
    if (d.getDay() === 0) d.setDate(d.getDate() + 1);
    return d;
  }

  function fmtDate(d, locale) {
    if (locale === 'en') {
      var s;
      try { s = d.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long' }); }
      catch (e) { s = d.toLocaleDateString('en-GB'); }
      return 'on ' + s;
    }
    // UA: день тижня після «у» вимагає знахідного відмінка
    // (середа→середу, пʼятниця→пʼятницю, субота→суботу, неділя→неділю;
    //  понеділок/вівторок/четвер — без змін).
    var wd, dm;
    try {
      wd = d.toLocaleDateString('uk-UA', { weekday: 'long' });
      dm = d.toLocaleDateString('uk-UA', { day: 'numeric', month: 'long' });
    } catch (e) {
      return 'у ' + d.toLocaleDateString('uk-UA');
    }
    wd = wd.replace(/а$/, 'у').replace(/я$/, 'ю');
    return 'у ' + wd + ', ' + dm;
  }

  function computeDates(locale) {
    var now = new Date();
    var ship = new Date(now);
    // Відсічка 12:00: до полудня — сьогодні, після — наступного дня.
    if (now.getHours() >= 12) ship.setDate(ship.getDate() + 1);
    skipSunday(ship);
    var receive = new Date(ship);
    receive.setDate(receive.getDate() + 1);
    skipSunday(receive);
    return { send: fmtDate(ship, locale), receive: fmtDate(receive, locale) };
  }

  // --- прогрес: двоступеневий (безкоштовна доставка + подарунок) ------------
  // ICECAT-731: якщо у блоці є data-ship-gift — показуємо дві віхи (як референс Medik8).
  function renderGift(block, cartTotal) {
    var free = parseInt(block.getAttribute('data-ship-threshold'), 10) || DEFAULT_THRESHOLD;
    var gift = parseInt(block.getAttribute('data-ship-gift'), 10) || (free * 2);
    var locale = block.getAttribute('data-locale') === 'en' ? 'en' : 'uk';
    var pct = Math.max(0, Math.min(100, Math.round((cartTotal / gift) * 100)));

    var fill = block.querySelector('[data-ship-bar]');
    if (fill) fill.style.inlineSize = pct + '%';

    var gotFree = cartTotal >= free, gotGift = cartTotal >= gift;
    block.classList.toggle('is-free', gotFree);
    block.classList.toggle('is-gift', gotGift);
    var nf = block.querySelector('[data-ship-node-free]');
    var ng = block.querySelector('[data-ship-node-gift]');
    if (nf) nf.classList.toggle('is-reached', gotFree);
    if (ng) ng.classList.toggle('is-reached', gotGift);

    var msg = block.querySelector('[data-ship-msg]');
    if (!msg) return;
    if (gotGift) {
      msg.innerHTML = locale === 'en'
        ? 'You’ve got <strong>free shipping</strong> + a <strong>gift</strong> 🎁'
        : 'У вас <strong>безкоштовна доставка</strong> та <strong>подарунок</strong> 🎁';
    } else if (gotFree) {
      var toGift = money(gift - cartTotal, locale);
      msg.innerHTML = locale === 'en'
        ? 'Free shipping unlocked — add <strong>' + toGift + '</strong> for a <strong>gift</strong>'
        : 'Безкоштовна доставка ✓ Ще <strong>' + toGift + '</strong> до <strong>подарунка</strong>';
    } else {
      var toFree = money(free - cartTotal, locale);
      msg.innerHTML = locale === 'en'
        ? 'Add <strong>' + toFree + '</strong> more for <strong>free shipping</strong>'
        : 'Ще <strong>' + toFree + '</strong> до <strong>безкоштовної доставки</strong>';
    }
  }

  // --- прогрес -------------------------------------------------------------
  function renderProgress(block, cartTotal) {
    if (block.hasAttribute('data-ship-gift')) return renderGift(block, cartTotal);
    var threshold = parseInt(block.getAttribute('data-ship-threshold'), 10) || DEFAULT_THRESHOLD;
    var locale = block.getAttribute('data-locale') === 'en' ? 'en' : 'uk';
    var remaining = Math.max(0, threshold - cartTotal);
    var pct = Math.max(0, Math.min(100, Math.round((cartTotal / threshold) * 100)));

    var fill = block.querySelector('[data-ship-bar]');
    if (fill) fill.style.inlineSize = pct + '%';

    var msg = block.querySelector('[data-ship-msg]');
    if (!msg) return;

    if (remaining <= 0) {
      block.classList.add('is-free');
      msg.innerHTML = locale === 'en'
        ? 'You’ve got <strong>free shipping</strong> 🎉'
        : 'У вас <strong>безкоштовна доставка</strong> 🎉';
    } else {
      block.classList.remove('is-free');
      var amount = money(remaining, locale);
      msg.innerHTML = locale === 'en'
        ? '<strong>' + amount + '</strong> to free shipping'
        : 'До безкоштовної доставки <strong>' + amount + '</strong>';
    }
  }

  function refreshCart() {
    var blocks = document.querySelectorAll('.ukoi-ship');
    if (!blocks.length) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = (cart && typeof cart.total_price === 'number') ? cart.total_price : 0;
        blocks.forEach(function (b) { renderProgress(b, total); });
      })
      .catch(function () {});
  }

  // --- ініт ----------------------------------------------------------------
  function init() {
    var blocks = document.querySelectorAll('.ukoi-ship');
    if (!blocks.length) return;

    blocks.forEach(function (block) {
      var locale = block.getAttribute('data-locale') === 'en' ? 'en' : 'uk';
      var dates = computeDates(locale);
      var s = block.querySelector('[data-ship-send]');
      var r = block.querySelector('[data-ship-receive]');
      if (s) s.textContent = dates.send;
      if (r) r.textContent = dates.receive;
    });

    refreshCart();

    // Надійний тригер оновлення: перехоплюємо будь-які запити зміни кошика.
    // Працює незалежно від розмітки теми (fetch — основний шлях у Horizon).
    var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/i;
    if (window.fetch && !window.__ukoiShipHook) {
      window.__ukoiShipHook = true;
      var _fetch = window.fetch;
      window.fetch = function (input) {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var res = _fetch.apply(this, arguments);
        if (CART_RE.test(url)) res.then(function () { setTimeout(refreshCart, 120); }, function () {});
        return res;
      };
    }
    // Плюс явні події кошика, які може диспатчити тема / наш quick-add,
    // та best-effort спостереження за лічильником кошика в хедері.
    ['cart:refresh', 'cart:updated', 'cart:change', 'variant:add'].forEach(function (ev) {
      document.addEventListener(ev, refreshCart);
    });
    var bubble = document.querySelector('.cart-bubble, [ref="cartBubble"], cart-icon, [data-cart-count]');
    if (bubble && 'MutationObserver' in window) {
      new MutationObserver(refreshCart).observe(bubble, {
        subtree: true, childList: true, characterData: true, attributes: true
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
